import { getSources } from '../../api/api'
import { isTimestampFresh } from '../../lib/utils'
import { logException } from '../../sentry'

export const FETCH_SOURCES = 'FETCH_SOURCES'
export const FETCH_SOURCES_SUCCESS = 'FETCH_SOURCES_SUCCESS'
export const FETCH_SOURCES_FAILURE = 'FETCH_SOURCES_FAILURE'

export function fetchSources(maxStaleSecs = 0) {
  return (dispatch, getState) => {
    const state = getState()
    const lastFetchTimestamp = state.sources.get('timestamp')
    const loading = state.sources.get('loading')
    if (loading || isTimestampFresh(lastFetchTimestamp, maxStaleSecs)) {
      return
    }

    dispatch({
      type: FETCH_SOURCES,
    })

    return getSources().then(response => {
      dispatch({
        type: FETCH_SOURCES_SUCCESS,
        timestamp: Date.now(),
        response,
      })
    }).catch((error) => {
      logException(error)
      dispatch({
        type: FETCH_SOURCES_FAILURE,
        error,
      })
    })
  }
}
